module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Ballet.04f57c4a.png";